import { AccessorsMutatorsDecorator } from "../../helpers";
import { Model } from "../../helpers";
import { NumberFormat } from "./number-format.model";
import { Currency } from "./currency.model";
import { tz } from "moment-timezone";
import moment from "moment";
import _ from "lodash";

/**
 * @class GeneralSettings
 * @property {number} id
 */
export class GeneralSettings extends Model {
  static get ARABIC_LANGUAGE() {
    return {
      key: "AR",
      value: "ARABIC",
    };
  }

  static get ENGLISH_LANGUAGE() {
    return {
      key: "EN",
      value: "ENGLISH",
    };
  }

  static get LANGUAGES() {
    return [this.ARABIC_LANGUAGE, this.ENGLISH_LANGUAGE];
  }

  static get GREGORIAN_DATE_FORMAT() {
    return {
      key: "dd/MM/yyyy",
      value: "GREGORIAN_DATE_FORMAT",
    };
  }

  static get USA_DATE_FORMAT() {
    return {
      key: "MM/dd/yyyy",
      value: "USA_DATE_FORMAT",
    };
  }

  static get DATE_FORMATS() {
    return [this.GREGORIAN_DATE_FORMAT, this.USA_DATE_FORMAT];
  }

  static get H24_FORMAT() {
    return {
      key: "24",
      value: "24_HOURS_TIME_FORMAT",
    };
  }

  static get H12_FORMAT() {
    return {
      key: "12",
      value: "12_HOURS_TIME_FORMAT",
    };
  }

  static get TIME_FORMATS() {
    return [this.H24_FORMAT, this.H12_FORMAT];
  }

  static get CURRENCY_FORMATS() {
    return Object.keys(NumberFormat.NUMBER_FORMATS).map((x) => ({
      key: x,
      value: x.replace(/ /g, "\u00a0"),
    }));
  }

  static get AUTO_ASSIGN_ALL() {
    return {
      key: 0,
      value: "ASSIGN_TO_ALL_EXISTING_AND_NEW_RESERVATIONS",
    };
  }

  static get AUTO_ASSIGN_NEW() {
    return {
      key: 1,
      value: "ASSIGN_TO_NEW_RESERVATIONS_ONLY",
    };
  }

  static get AUTO_ASSIGN_TYPES() {
    return [this.AUTO_ASSIGN_ALL, this.AUTO_ASSIGN_NEW];
  }

  static get SURNAME_FIRST_FORMAT() {
    return {
      key: 0,
      value: "SURNAME_NAME",
    };
  }

  static get NAME_FIRST_FORMAT() {
    return {
      key: 1,
      value: "NAME_SURNAME",
    };
  }

  static get CUSTOMER_NAME_FORMATS() {
    return [this.SURNAME_FIRST_FORMAT, this.NAME_FIRST_FORMAT];
  }

  static get TIME_ZONES() {
    const valueString = (x) =>
      this.$translate.use() === "en"
        ? `(GMT ${tz(x).format("Z")}) ${x}`
        : `GMT ${tz(x).format("Z")}) ${x})`;
    const timeOffset = (timezone) => tz(timezone).utcOffset();

    const nameCompare = (left, right) => left.localeCompare(right);
    const offsetCompare = (left, right) => timeOffset(left) - timeOffset(right);

    return _.chain(tz.names())
      .sortBy(nameCompare)
      .sortBy(offsetCompare)
      .value()
      .map((x) => ({
        key: x,
        value: valueString(x),
      }));
  }

  /**
   * @param {Object|Currency} value
   * @returns {Currency}
   */
  setCurrency(value) {
    return value && (value instanceof Currency ? value : new Currency(value));
  }

  setIsAutoAssign(value) {
    if (angular.isUndefined(this._instance)) {
      this._instance = true;
      this.auto_assign_type = this.constructor.AUTO_ASSIGN_NEW.key;
    }

    return value;
  }

  getIsAutoAssign(value = false) {
    return value;
  }

  setAutoAssignType(value) {
    if (angular.isUndefined(this._instance) && value !== null) {
      this._instance = true;
      this.is_auto_assign = true;
    }

    value = parseInt(value);
    return value;
  }

  getAutoAssignType(value) {
    return this.is_auto_assign ? value : 0;
  }

  setIsShowTime(value) {
    if (angular.isUndefined(this._show_instance)) {
      this._show_instance = true;
      this.local_no_show_time = "23:59";
    }

    return value;
  }

  getLocalIsShowTime(value = false) {
    return value;
  }

  setLocalNoShowTime(value) {
    if (angular.isUndefined(this._show_instance) && value !== null) {
      this._show_instance = true;
      this.is_show_time = true;
    }

    return moment(value, "HH:mm");
  }

  getNoShowTime(value) {
    return this.is_show_time ? moment(value, "HH:mm") : null;
  }

  setNoShowTime(value) {
    this.local_no_show_time = value;

    return value;
  }

  getNoShowTime(value) {
    return this.is_show_time
      ? moment(this.local_no_show_time, "HH:mm").format("HH:mm")
      : null;
  }
}

AccessorsMutatorsDecorator(
  "id",
  "property_id",
  "application_language",
  "auto_assign_type",
  "currency_id",
  "currency",
  "currency_format",
  "customer_name_format",
  "date_format",
  "default_customer_country",
  "estimated_arrival_time",
  "no_show_time",
  "private_accommodation",
  "time_format",
  "time_zone",
  "is_auto_assign",
  "auto_checkout",
  "is_show_time",
  "local_no_show_time",
  "enable_guest_evaluation",
  "enable_guest_search_in_mabeet_db",
  "display_hijri_date_in_invoices",
  "enable_check_out_with_balance_due",
)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/pms-api/models/general-settings.model.js